import { useTranslation } from 'react-i18next';



import React, { useState, useEffect, useRef } from "react";


function StaticPromo({ img_url, title, subtitle, handleOpenRegisterModal, isLogged, lang }) {
  const { t } = useTranslation();

  return (


    <>
    
    <div className="static-promotion" ><img src={img_url} style={{height:"unset"}}/>

      {/* <div className="text-slider" style={{width:"100%"}}>

        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>

      
          <div className="bt-slide">
            {!isLogged && (
            <a href="#" 
              className="btn btn-sm btn-registration"
              onClick={(e) => {
                e.preventDefault();
                handleOpenRegisterModal();
              }}
            >
              {t('Sign_Up')}
            </a>
              )}
          </div> 
      </div> */}

    </div>

    </>

    
  );
}

export default StaticPromo;








